/**
 * Global enforcement gate (PRD P0.7): while a blocking condition is up
 * (seat limit 429), tile loading is paused so the viewer does not hammer
 * the proxy with a retry storm. Unblocking refreshes every registered
 * WMS source.
 */
export type GateListener = (blocked: boolean, message: string) => void

class EnforcementGate {
  blocked = false
  message = ''
  private listeners = new Set<GateListener>()
  private refreshers = new Set<() => void>()

  block(message: string): void {
    if (this.blocked) return
    this.blocked = true
    this.message = message
    this.emit()
  }

  unblock(): void {
    if (!this.blocked) return
    this.blocked = false
    this.message = ''
    this.emit()
    this.refreshers.forEach((refresh) => refresh())
  }

  onChange(listener: GateListener): void {
    this.listeners.add(listener)
  }

  registerRefresher(refresh: () => void): void {
    this.refreshers.add(refresh)
  }

  refreshAll(): void {
    this.refreshers.forEach((refresh) => refresh())
  }

  reset(): void {
    this.blocked = false
    this.message = ''
    this.listeners.clear()
    this.refreshers.clear()
  }

  private emit(): void {
    this.listeners.forEach((listener) => listener(this.blocked, this.message))
  }
}

export const gate = new EnforcementGate()
